import { useContext, useState } from "react"
import { bool, func } from "prop-types"
import { Checkbox, Pane } from "components/ui"
import LegacyRegistrationContact from "components/admin/registration_contact"
import RegisterableContext from "components/admin/registerable/context"
import { Button } from "@planningcenter/tapestry-react"

const RegistrationContact = ({
  sendConfirmation = false,
  onSendConfirmationChange,
  hasNamedAttendees,
  isClearable
}) => {
  const { loading, registerable } = useContext(RegisterableContext)
  const [isEditing, setIsEditing] = useState(false)

  const handlePersonChange = person => {
    const responsible_person_id = person?.account_center_id || person?.accountCenterId || null
    registerable.update({ responsible_person_id })
    setIsEditing(false)
  }

  const suggestedPeople = [
    registerable?.responsiblePerson,
    ...(registerable?.attendees?.map(attendee => attendee.person) || [])
  ]
    .filter(person => !!person)
    .map(person => ({ ...person, accountCenterId: person.id }))

  const EditButton = () => {
    if (isClearable) {
      return null
    } else {
      return isEditing ? (
        <Button onClick={() => setIsEditing(false)} title="Cancel" variant="outline" size="xs" />
      ) : (
        <Button title="Edit" onClick={() => setIsEditing(true)} variant="outline" size="xs" />
      )
    }
  }

  return (
    <>
      <Pane css={{ position: "relative", zIndex: 2 }} marginBottom={1}>
        <Pane.Header>
          <Pane.Title>Registration contact</Pane.Title>
          <EditButton />
        </Pane.Header>
        <Pane.Body>
          <LegacyRegistrationContact
            responsiblePerson={
              registerable?.responsiblePerson
                ? {
                    ...registerable.responsiblePerson,
                    person_url: `/people/AC${registerable.responsiblePerson.id}`
                  }
                : null
            }
            suggestedPeople={suggestedPeople}
            onSelect={handlePersonChange}
            isSaving={loading}
            isAdmin={true}
            hasNamedAttendees={hasNamedAttendees}
            editMode={isClearable ? null : isEditing}
            isClearable={isClearable}
          />
        </Pane.Body>
        {onSendConfirmationChange && (
          <Pane.Body className="line">
            <Checkbox
              name="send_email"
              htmlFor="send_email"
              value="bar"
              checked={sendConfirmation}
              onSelect={onSendConfirmationChange}
              text="Send confirmation email"
              wrapperClasses="mb-0"
            />
          </Pane.Body>
        )}
      </Pane>
    </>
  )
}

RegistrationContact.propTypes = {
  sendConfirmation: bool,
  onSendConfirmationChange: func,
  hasNamedAttendees: bool,
  isClearable: bool
}

export default RegistrationContact
